import { addDoc, collection, getDoc, getDocs, query, doc, updateDoc } from '@firebase/firestore';
import { db } from '../firebase/firebase-config';
import { Timestamp } from 'firebase/firestore';
import { handleError, whichEnvURL } from '../helpers/utils';

// Create notification
export const createTicket = async (data) => {
	const dbRef = collection(
		db,
		whichEnvURL(true) === 'live' ? 'tickets' : 'tickets_stage'
	);

	try {
		return await addDoc(dbRef, {
			...data,
			created: Timestamp.fromDate(new Date()),
		});
	} catch (error) {
		handleError(error, 'Ocurrió un error al crear la notificación [x]');
	}
};

// Get tickets
export const getTickets = async () => {
	const dbRef = collection(
		db,
		whichEnvURL(true) === 'live' ? 'tickets' : 'tickets_stage'
	);

	try {
		return await getDocs(query(dbRef));
	} catch (error) {
		handleError(error, 'Ocurrió un error al obtener los tickets');
	}
};

// Get ticket by ID
export const getTicketById = async (id) => {
	const dbRef = doc(
		db,
		whichEnvURL(true) === 'live' ? 'tickets' : 'tickets_stage',
		id
	);

	try {
		return await getDoc(dbRef);
	} catch (error) {
		handleError(error, 'Ocurrió un error al obtener el ticket');
	}
};

export const updateTicketById = async (id, newData) => {
    const dbRef = doc(
        db,
        whichEnvURL(true) === 'live' ? 'tickets' : 'tickets_stage',
        id
    );

    try {
        return await updateDoc(dbRef, newData);
    } catch (error) {
        handleError(error, 'Ocurrió un error al actualizar el ticket');
    }
};

// // Update notification
// export const updateTicket = (id = null, isDone = false, user) => {
// 	if (!id) handleError(null, 'El id de la notificación no es válido');

// 	updateDoc(
// 		doc(
// 			db,
// 			whichEnvURL(true) === 'live'
// 				? 'notifications'
// 				: 'notifications_stage',
// 			id
// 		),
// 		{
// 			isDone: !isDone,
// 			solved_date: !isDone ? Timestamp.fromDate(new Date()) : null,
// 			updated: Timestamp.fromDate(new Date()),
// 			reviewed_by: getUserBasicInfo(user),
// 		}
// 	).then(() => {
// 		handleSuccess('Notificación actualizada');
// 	});
// };
